import React from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";
import { ExerciseItem, getExerciseContent } from "@/services/student/exercise.interfaces";

// Interface para o conteúdo do exercício StyledSection
interface StyledSectionContent {
  title: string;
  description?: string;
  icon?: string;
  titleColor?: string;
  borderStyle?: 'solid' | 'dashed' | 'dotted' | 'none';
}

// Props do componente
type StyledSectionProps = {
  item: ExerciseItem;
};

export const StyledSection: React.FC<StyledSectionProps> = ({ item }) => {
  // Extrair e tipar o conteúdo do exercício
  const content = getExerciseContent<StyledSectionContent>(item);

  // Estilo para o título da seção
  const titleStyle = {
    color: content.titleColor || "#4B5563",
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: 1.2,
    marginBottom: "0.75rem",
  };

  // Estilo para o container da seção
  const sectionContainerStyle = {
    borderTop: content.borderStyle ? `2px ${content.borderStyle} #E5E7EB` : "2px solid #E5E7EB",
    paddingTop: "1.5rem",
    marginTop: "1rem",
  };

  // Definir ícone (se houver)
  const renderIcon = () => {
    if (!content.icon) return null;
    
    // Verificar se é uma URL (começa com http ou https)
    if (content.icon.startsWith('http')) {
      return (
        <img 
          src={content.icon} 
          alt="Ícone da seção" 
          className="w-6 h-6 mr-2"
        />
      );
    } 
    
    // Caso contrário, assumimos que é um nome de classe de ícone
    return (
      <span className={`${content.icon} mr-2`}></span>
    );
  };

  return (
    <ExerciseTypeContainer
      item={item}
      title1={item.title}
      exerciseNumber={item.id.toString()}
      hideVerifyButton={true}
    >
      <div style={sectionContainerStyle} className="styled-section-container">
        <div className="flex items-center">
          {renderIcon()}
          <h2 style={titleStyle}>{content.title}</h2>
        </div>
        
        {content.description && (
          <div className="text-gray-600 mt-2">
            {content.description}
          </div>
        )}
      </div>
    </ExerciseTypeContainer>
  );
}; 